import * as React from "react";
import type { SVGProps } from "react";
const SvgPaymentCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2M11 16h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 20h12a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4M4 9V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1zm0 2h16v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPaymentCard;
